<template>
    <v-card>
        <v-form ref="form" v-model="form">
        <v-card-title>
            Changement de Mot de Passe
        </v-card-title>
        <v-card-text class="text-left">
            <p>Utilisateur d'Idendifiant : <b>{{user.username}}</b></p>
            <p>Email : <b>{{user.email}}</b></p>
            <v-text-field
            class="my-5"
            label="Mot de passe"
            v-model="password"
            outlined
            :rules="[rules.required, rules.password]"
            type="password"
            dense
            persistent-hint hint="Veuillez choisir une mot de passe contenant au moins 8 caractères."
            ></v-text-field>
            <v-text-field
            class="my-5"
            label="Confirmer Mot de passe"
            v-model="confirm_password"
            :rules="[rules.required, rules.password ,(this.password === this.confirm_password) || 'Les deux sont devaient être identiques.']"
            outlined
            dense
            type="password"
            ></v-text-field>
            <p><b>Veuillez noter que l'utilisateur concerné sera informé de ce changement par un email.</b></p>
        </v-card-text>
        <v-card-actions class="py-5">
            <v-spacer></v-spacer>
            <v-btn
            color="primary darken-1"
            text
            @click="$emit('hide')"
            >
            Annuler
            </v-btn>
            <v-btn
            style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px; color:white;"
            @click="changePasswordAction"
            >
            Ajouter
            </v-btn>
        </v-card-actions>
        </v-form>
        </v-card>
</template>
<script>
export default {
    name: 'change-pwd',
    props: ['user'],
    data : ()=> ({
        password: '',
        confirm_password: '',
        form: false,
        rules: {
            required: value => !!value || 'Ce champs est obligatoire.',
            password: value => value.length >= 8 || 'Le mot de passe doit contenir au moins 8 caractères.',
        },
    }),
    methods: {
        changePasswordAction(){
            let userId = this.user.id
            let credentials = this.$store.getters.getUser
            if(this.$refs.form.validate()){
                this.axios
                    .post("/user/"+userId+"/change_pw_by_credentials/"+credentials, {new_password: this.password})
                    .then(res => {
                        this.$emit('print_message', {color: 'success', text: 'Le mot de passe a été changé avec succès.'})
                        this.$emit('hide')
                    })
            }
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/views/dashboard/users/actions/change_pwd.vue